export default __webpack_public_path__ + "static/media/TUSD-USDT.bf448e53.png";